/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hide_ScoresInputs */

const th_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซ่อนคะแนน`)
};

const en_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide scores`)
};

const ja_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スコアを隠す`)
};

const zh_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏比分`)
};

const es_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar resultados`)
};

const pt_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar placares`)
};

const id_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan skor`)
};

const fr_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les scores`)
};

const tl_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itago ang mga iskor`)
};

const vi_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ẩn tỉ số`)
};

const ko_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수 숨기기`)
};

const de_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse ausblenden`)
};

const ru_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть счёт`)
};

const tr_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skorları gizle`)
};

const it_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi i punteggi`)
};

const pl_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukryj wyniki`)
};

const uk_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приховати рахунок`)
};

const hi_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कोर छिपाएँ`)
};

const ar_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إخفاء النتائج`)
};

const ms_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan mata`)
};

const bn_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর লুকান`)
};

const zh_tw2_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱藏比分`)
};

const zh_hk2_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱藏比分`)
};

const ur_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکور چھپائیں`)
};

const fa_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پنهان کردن نتایج`)
};

const sw_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficha matokeo`)
};

const nl_hide_scores = /** @type {(inputs: Hide_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitslagen verbergen`)
};

/**
* | output |
* | --- |
* | "Hide scores" |
*
* @param {Hide_ScoresInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const hide_scores = /** @type {((inputs?: Hide_ScoresInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hide_ScoresInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_hide_scores(inputs)
	if (locale === "ja") return ja_hide_scores(inputs)
	if (locale === "zh") return zh_hide_scores(inputs)
	if (locale === "es") return es_hide_scores(inputs)
	if (locale === "pt") return pt_hide_scores(inputs)
	if (locale === "id") return id_hide_scores(inputs)
	if (locale === "fr") return fr_hide_scores(inputs)
	if (locale === "tl") return tl_hide_scores(inputs)
	if (locale === "vi") return vi_hide_scores(inputs)
	if (locale === "ko") return ko_hide_scores(inputs)
	if (locale === "de") return de_hide_scores(inputs)
	if (locale === "ru") return ru_hide_scores(inputs)
	if (locale === "tr") return tr_hide_scores(inputs)
	if (locale === "it") return it_hide_scores(inputs)
	if (locale === "pl") return pl_hide_scores(inputs)
	if (locale === "uk") return uk_hide_scores(inputs)
	if (locale === "hi") return hi_hide_scores(inputs)
	if (locale === "ar") return ar_hide_scores(inputs)
	if (locale === "ms") return ms_hide_scores(inputs)
	if (locale === "bn") return bn_hide_scores(inputs)
	if (locale === "zh-TW") return zh_tw2_hide_scores(inputs)
	if (locale === "zh-HK") return zh_hk2_hide_scores(inputs)
	if (locale === "ur") return ur_hide_scores(inputs)
	if (locale === "fa") return fa_hide_scores(inputs)
	if (locale === "sw") return sw_hide_scores(inputs)
	if (locale === "nl") return nl_hide_scores(inputs)
	return en_hide_scores(inputs)
});